import type { MerchantPayWithFlexaSchema } from "./types";

export const merchants: MerchantPayWithFlexaSchema[] = [
  {
    logoUrl: "https://flexa.media/brands/rcPmChVG7xwVVj4g2Q68q.svg",
    name: "ABC Stores",
    id: "abc-stores",
    color: "#1e4099",
    category: "Convenience Store",
    pay_style: "universal_qr_payment",
    links: {
      website: "https://abcstores.com/",
      facebook: "https://www.facebook.com/abcstores/",
      twitter: "https://x.com/abcstoreshawaii",
      instagram: "https://www.instagram.com/abcstores/",
    },
    all_locations: true,
    locations: [],
  },
  {
    logoUrl: "https://flexa.media/brands/p5whfWqrFv3g8GwP7HQG8.svg",
    name: "Barnes & Noble",
    id: "barnes-and-noble",
    color: "#53575a",
    category: "Retail",
    pay_style: "legacy_flexcode",
    links: {
      website: "https://www.barnesandnoble.com/",
      facebook: "https://www.facebook.com/barnesandnoble",
      twitter: "https://x.com/bnbuzz",
      instagram: "https://www.instagram.com/barnesandnoble/",
    },
    all_locations: true,
    locations: [],
  },
  {
    logoUrl: "https://flexa.media/brands/mXGRG9MvhwGpvP4c8hmHM.svg",
    name: "Chipotle",
    id: "chipotle",
    color: "#ac2318",
    category: "Mexican Restaurant",
    pay_style: "legacy_flexcode",
    links: {
      website: "https://www.chipotle.com/",
      facebook: "https://www.facebook.com/chipotle",
      twitter: "https://x.com/chipotletweets",
      instagram: "https://www.instagram.com/chipotle/",
    },
    all_locations: true,
    locations: [],
  },
  {
    logoUrl: "https://flexa.media/brands/QP8qXhJ44fxx7MhwpfCCG.svg",
    name: "Coco Bubble Tea",
    id: "coco-bubble-tea",
    color: "#f09701",
    category: "Bubble Tea Shop",
    pay_style: "universal_qr_payment",
    links: {
      website: "https://cocobubbletea.com/",
      facebook: "https://www.facebook.com/cocotea.eastcoast",
      twitter: "https://x.com/cocoteausa",
      instagram: "https://www.instagram.com/cocotea.eastcoast/",
    },
    all_locations: true,
    locations: [],
  },
  {
    logoUrl: "https://flexa.media/brands/fX3qM77HR7WCGcJFJvHwr.svg",
    name: "Dior",
    id: "dior",
    category: "Fashion Boutique",
    pay_style: "universal_qr_payment",
    color: "#000000",
    links: {
      website: "https://www.dior.com",
      facebook: "https://www.facebook.com/Dior",
      twitter: "https://x.com/Dior",
      instagram: "https://www.instagram.com/dior",
    },
    all_locations: true,
    locations: [],
  },
  {
    logoUrl: "https://flexa.media/brands/JQQc3qCQ23W9Gg473R3Qh.svg",
    name: "Fresh",
    id: "fresh",
    color: "#283f47",
    category: "Cosmetics",
    pay_style: "universal_qr_payment",
    links: {
      website: "https://www.fresh.com/us/home",
      facebook: "https://www.facebook.com/fresh",
      twitter: "https://x.com/freshbeauty",
      instagram: "https://www.instagram.com/freshbeauty/",
    },
    all_locations: true,
    locations: [],
  },
  {
    logoUrl: "https://flexa.media/brands/6q8MfhrwcM95gMWFf3WX3.svg",
    name: "GameStop",
    id: "gamestop",
    color: "#242424",
    category: "Gaming Retailer",
    pay_style: "legacy_flexcode",
    links: {
      website: "https://www.gamestop.com/",
      facebook: "https://www.facebook.com/GameStop/",
      twitter: "https://x.com/GameStop",
      instagram: "https://www.instagram.com/gamestop/",
    },
    all_locations: true,
    locations: [],
  },
  {
    logoUrl: "https://flexa.media/brands/Wvj9884VmrxCj4mHXvc27.svg",
    name: "International Shoppes",
    id: "international-shoppes",
    color: "#18437e",
    category: "Speciality Retailer",
    pay_style: "universal_qr_payment",
    links: {
      website: "https://www.ishoppes.com",
      facebook: "https://www.facebook.com/isdutyfree",
      twitter: "https://x.com/isdutyfree",
      instagram: "https://www.instagram.com/isdutyfree",
    },
    all_locations: true,
    locations: [],
  },
  {
    logoUrl: "https://flexa.media/brands/64cWWffff9P83Fmh9Vj9C.svg",
    name: "Kiehl's",
    id: "kiehls",
    color: "#000000",
    category: "Cosmetics",
    pay_style: "universal_qr_payment",
    links: {
      website: "https://www.kiehls.com/",
      facebook: "https://www.facebook.com/KiehlsUS/",
      twitter: "https://x.com/kiehls",
      instagram: "https://www.instagram.com/kiehls/",
    },
    all_locations: true,
    locations: [],
  },
  {
    logoUrl: "https://flexa.media/brands/Q8hQmMqxv4fCPVVpvpRgw.svg",
    name: "Mikimoto",
    id: "mikimoto",
    category: "Jewelry",
    pay_style: "universal_qr_payment",
    color: "#252525",
    links: {
      website: "https://www.mikimotoamerica.com",
      facebook: "https://www.facebook.com/MIKIMOTO",
      twitter: "https://x.com/mikimoto_us",
      instagram: "https://www.instagram.com/official_mikimoto",
    },
    all_locations: true,
    locations: [],
  },
  {
    logoUrl: "https://flexa.media/brands/mchgvHw7p6gq8f5W3WjRr.svg",
    name: "Regal",
    id: "regal",
    color: "#ff6900",
    category: "Entertainment",
    pay_style: "legacy_flexcode",
    links: {
      website: "https://www.regmovies.com/",
      facebook: "https://www.facebook.com/RegalMovies/",
      twitter: "https://x.com/RegalMovies",
      instagram: "https://www.instagram.com/regalmovies/",
    },
    all_locations: true,
    locations: [],
  },
  {
    logoUrl: "https://flexa.media/brands/2MfqVfp5HPHq5MVQm73Fv.svg",
    name: "Sheetz",
    id: "sheetz",
    category: "Convenience Store",
    pay_style: "legacy_flexcode",
    color: "#dc132b",
    links: {
      website: "https://www.sheetz.com",
      facebook: "https://www.facebook.com/sheetz",
      twitter: "https://x.com/sheetz",
      instagram: "https://www.instagram.com/sheetz",
    },
    all_locations: true,
    locations: [],
  },
  {
    logoUrl: "https://flexa.media/brands/6qG8jPFhHfffGQqQJ2mqV.svg",
    name: "Ulta Beauty",
    id: "ulta-beauty",
    color: "#f47d39",
    category: "Cosmetics",
    pay_style: "legacy_flexcode",
    links: {
      website: "https://www.ulta.com/",
      facebook: "https://www.facebook.com/UltaBeauty/",
      twitter: "https://x.com/ultabeauty",
      instagram: "https://www.instagram.com/ultabeauty/",
    },
    all_locations: true,
    locations: [],
  },
  {
    logoUrl: "https://flexa.media/brands/q9McVwGQ6h3QWwCWmHMq3.svg",
    name: "99 Ranch Market",
    id: "99-ranch-market",
    color: "#2b7050",
    category: "Supermarket",
    pay_style: "universal_qr_payment",
    links: {
      website: "https://www.99ranch.com/",
      facebook: "https://www.facebook.com/99RanchMarket",
      twitter: "https://x.com/99RanchMarket",
      instagram: "https://www.instagram.com/99ranchmarket/",
    },
    all_locations: true,
    locations: [],
  },
];
